query tipoProcessoSelect($where: EnumItemDTOFilterInput) {
    data: tiposProcessos(where: $where)  {
        label
        value
    }
}